import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { GameScoreService, GameScoreEntry } from '../../services/game-score.service';

@Component({
  selector: 'app-game-scores-popup',
  templateUrl: './game-scores-popup.component.html',
  styleUrls: ['./game-scores-popup.component.scss']
})
export class GameScoresPopupComponent implements OnInit {
  @Input() gameId!: string;
  @Input() gameTitle = 'Scores';
  @Output() closed = new EventEmitter<void>();

  activeTab: 'top' | 'me' = 'top';
  topScores: GameScoreEntry[] = [];
  myScores: GameScoreEntry[] = [];
  loading = true;

  constructor(private gameScoreService: GameScoreService) {}

  ngOnInit(): void {
    this.loadScores();
  }

  async loadScores(): Promise<void> {
    this.loading = true;
    try {
      const [top, me] = await Promise.all([
        this.gameScoreService.getTopScores(this.gameId, 10),
        this.gameScoreService.getMyScores(this.gameId, 10),
      ]);
      this.topScores = top || [];
      this.myScores = me || [];
    } catch (e) {
      console.error('Erreur chargement scores', e);
      this.topScores = [];
      this.myScores = [];
    }
    this.loading = false;
  }

  close(): void {
    this.closed.emit();
  }

  onBackdropClick(event: MouseEvent): void {
    if ((event.target as HTMLElement).classList.contains('scores-backdrop')) {
      this.close();
    }
  }
}
